








































import { Component, Vue } from "vue-property-decorator";
import BodyHead from "_C/main/BodyHead.vue";
import { getPlural } from "@/plugins/strings";
import { GaHelper } from "@/core/helpers/ga";
import { CalcStatus } from '@/models/Models';

@Component({
    components: { BodyHead }
})
export default class IssueInProcess extends Vue {
    getPlural = getPlural;

    created() {
        this.$store.direct.commit.iccalc.startBuyTimer();
    }
    mounted() {
        GaHelper.send("issueInProcess");
    }

    get loaderText() {
        return this.isFastCalcDisabled ? 'Подождите, пожалуйста, пока мы рассчитываем стоимость полиса' : 'Проверка данных и формирование ссылки на оплату...';
    }

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    get isSomeCalcLoading() {
        const readyStatuses = [
            CalcStatus.PreScoringSuccess,
            CalcStatus.Issued,
            CalcStatus.CalcSuccess,
            CalcStatus.CalcFail,
            CalcStatus.NeedToSelectCar
            // CalcStatus.IssueRejected
        ];
        return this.$store.direct.state.iccalc.calcStates.some((x) => !readyStatuses.includes(x.status));
    }

    get time(): number {
        return this.$store.direct.state.iccalc.buyTime;
    }
    get minutes(): number {
        return Math.floor(this.time / 60);
    }
    get seconds(): number {
        return this.time % 60;
    }
    get getTimeString(): string {
        let minutes = "";
        const plur = v => getPlural(v, "а", "ы", "");
        if (this.minutes) {
            minutes = `${this.minutes} минут${plur(this.minutes)} `;
        }
        const seconds = `${this.seconds} секунд${plur(this.seconds)}`;
        return `${minutes}${seconds}`;
    }
}
